export default __webpack_public_path__ + "static/media/inner_circle.376f64e7.svg";